/* eslint-disable react/jsx-no-target-blank */
import BasicLogin from '@/components/LoginPanel';
import Wave from '@/common/components/BasicLogin/components/Wave';
import classNames from 'classnames';
import React from 'react';
import styles from './index.less';

/** 登录 */
const Login: React.FC = () => {
  const pathname = window.location.pathname;
  return (
    <div className={styles['login-panel']}>
      <div className={classNames(styles.logo)} />
      <div className={styles['login-container']}>
        {/* <div className={styles['left-container']}>
          <div className={styles['left-logo']} />
          <div className={styles['left-technology']}>
            <a style={{ color: '#FFFFFF' }} target="_blank" href="https://beian.miit.gov.cn/">
              粤ICP备2022073478号-1
            </a>
            Copyright 2008 - {dayjs(new Date()).format('YYYY')} Sinohealth, All Rights Reserved
          </div>
        </div> */}
        <div className={styles['right-container']}>
          <div className={styles.loginTitle}>账号登录</div>
          <BasicLogin
            qrcodeLogin={false}
            platformName="《全病程管理服务平台》"
            defaultLogin={true}
            protocolBool
            serviceProtocolUrl={`${pathname}user-agreement.html`}
            privacyProtocolUrl={`${pathname}privact-agreement.html`}
          />
        </div>
        <div className={classNames(styles['login-procol'])}>京ICP备2023026881号</div>
      </div>
      <Wave />
    </div>
  );
};

export default Login;
